import React, { useEffect, useMemo, useState } from 'react';
import { Button, Container, createTheme, IconButton, Paper, ThemeProvider, CssBaseline, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Select, MenuItem, SelectChangeEvent, FormControl, InputLabel, Link, Stack, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, NavigateFunction, Navigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import HotelIcon from '@mui/icons-material/Hotel';
import TrainIcon from '@mui/icons-material/Train';
import { format } from 'date-fns';
import { Vuoro, Juna } from './Kirjaa';
import ICAL from 'ical.js';
import { CalendarToday } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import Joyride, { Step } from "react-joyride";

interface Props {
    token: string,
    kayttajaId: number
    setSuurinJarjestysNum: (suurinJarjestysNum: number) => void;
}





interface JunanAsemat {
    trainNumber: number;
    departureDate: string;
    operatorUICCode: number;
    operatorShortCode: string;
    trainType: string;
    trainCategory: string;
    commuterLineID: string;
    runningCurrently: boolean;
    cancelled: boolean;
    version: number;
    timetableType: string;
    timetableAcceptanceDate: string;
    timeTableRows: TimeTableRow[];
}

interface TimeTableRow {
    stationShortCode: string;
    stationUICCode: number;
    countryCode: string;
    type: string;
    trainStopping: boolean;
    commercialStop?: boolean;
    commercialTrack: string;
    cancelled: boolean;
    scheduledTime: string;
    actualTime?: string;
    differenceInMinutes: number;
    causes: any[];
    trainNumber: number;
    trainReady?: TrainReady;
    liveEstimateTime?: string;
    estimateSource?: string;
    omaEtaisyys: number;
    omaEstimate: number;
}

interface TrainReady {
    source: string;
    accepted: boolean;
    timestamp: string;
}

const Ajot: React.FC<Props> = (props: Props): React.ReactElement => {
 
    const navigate: NavigateFunction = useNavigate();



    const [avaaVuoro, setAvaaVuoro] = useState<number | null>(null);
    const [events, setEvents] = useState<any[]>([]);
    const [selectedEventIndexes, setSelectedEventIndexes] = useState<number[]>([]);
    const [valinta, setValinta] = useState("kuukausi"); // "kuukausi" tai "jakso"
    const [selectedJakso, setSelectedJakso] = useState("");

    const handleValintaChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setValinta(event.target.value);
        setSelectedMonth("");
        setSelectedJakso("");
    };

    const handleJaksoChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setSelectedJakso(event.target.value);
    };

    const [selectedMonth, setSelectedMonth] = useState<string>(() => {
        const currentMonth = new Date().getMonth() + 1;
        return currentMonth.toString().padStart(2, '0');
    });

    const [run, setRun] = useState(false); // Käynnistetään tutorial vasta, kun nappia painetaan

    const steps: Step[] = [
        {
            target: "#uusi-tyovuoro",
            content: "Tässä voit etsiä tietoja.",
        },
        {
            target: "#lisays-nappi",
            content: "Paina tästä lisätäksesi uuden tietueen.",
        },
        {
            target: "#asetukset",
            content: "Täältä pääset asetuksiin.",
        },
    ];

    const handleMonthChange = (event: SelectChangeEvent<string>) => {
        setSelectedMonth(event.target.value);
    };

    const [filteredValmis, setFilteredValmis] = useState<boolean>(false);

    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());



    const handleYearChange = (event: SelectChangeEvent<number>) => {
        setSelectedYear(event.target.value as number);
    };


    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const content = e.target?.result as string;
                parseIcs(content);
            };
            reader.readAsText(file);
        }
    };


    const parseIcs = (icsData: string) => {
        const jcalData = ICAL.parse(icsData);
        const comp = new ICAL.Component(jcalData);
        const vevents = comp.getAllSubcomponents('vevent');

        const events = vevents.map((vevent) => {
            const event = new ICAL.Event(vevent);
            return {
                summary: event.summary,
                startDate: event.startDate.toString(),
                endDate: event.endDate.toString(),
                description: event.description,
                location: event.location,
            };
        });

        setEvents(events);
    };



    const vieExceliin = () => {

        let edellinenVuoroId: number = 0;

        const filteredVuorot = apiData.tyovuorot.filter((vuoro: Vuoro) => vuoro.userid === props.kayttajaId);

        const junatValmis = filteredVuorot.flatMap((vuoro: Vuoro) => {
            return vuoro.junat.map((juna) => {


                const erilainenVuoro = vuoro.id !== edellinenVuoroId;
                edellinenVuoroId = vuoro.id;

                return {

                    tyoaika: erilainenVuoro ? vuoro.tyoaika : '',
                    vuoroAlkaa: erilainenVuoro ? vuoro.vuoroalkaa : '',
                    vuoroLoppuu: erilainenVuoro ? vuoro.vuoroloppuu : '',
                    latunnit: erilainenVuoro ? vuoro.latunnit : '',
                    sutunnit: erilainenVuoro ? vuoro.sutunnit : '',
                    yotunnit: erilainenVuoro ? vuoro.yotunnit : '',
                    iltatunnit: erilainenVuoro ? vuoro.iltatunnit : '',
                    matkatunnit: erilainenVuoro ? vuoro.matkatunnit : '',
                    paivystystunnit: erilainenVuoro ? vuoro.paivystystunnit : '',
                    tsl: erilainenVuoro ? vuoro.tsl : '',
                    jarjestysNum: juna.jarjestysNum,
                    junanumero: juna.junanumero,
                    pvm: juna.pvm,
                    mista: juna.mista,
                    mihin: juna.mihin,
                    veturi: juna.veturi,
                    akselit: juna.akselit,
                    pituus: juna.pituus,
                    junapaino: juna.junapaino,
                    JP: juna.JP,
                    JPP: juna.JPP,
                    lahtoaika: juna.lahtoaika,
                    saapumisaika: juna.saapumisaika,
                    lahtoaikam: juna.lahtoaikam,
                    saapumisaikam: juna.saapumisaikam,
                    kmM: juna.kmM,
                    kmT: juna.kmT,
                    vapaateksti: juna.vapaateksti,
                    matkustus: juna.matkustus
                };
            });
        });


        const ws = XLSX.utils.json_to_sheet(junatValmis);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Junat');
        XLSX.writeFile(wb, 'junat.xlsx');
    };



    const handleAvaaVuoro = (id: number) => {
        setAvaaVuoro(prevState => (prevState === id ? null : id));
    };

    const handleIconClick = async (index: number) => {


        setSelectedEventIndexes((prevSelectedIndexes) => [
            ...prevSelectedIndexes,
            index, // Just add the index to the array
        ]);




        const selectedEvent = events.at(index);  // Get the selected event
        if (selectedEvent) {
            const startDate = new Date(selectedEvent.startDate); // Extract the start date
            const endDate = new Date(selectedEvent.endDate); // Extract the end date

            // Create a Vuoro object based on the selected event
            const newVuoro: Vuoro = {
                id: 0, // Incrementing ID for simplicity
                vuoroalkaa: startDate,
                vuoroloppuu: endDate,
                tyoaika: calculateWorkingHours(startDate, endDate), // You can write your own function to calculate this
                latunnit: 0, // You can populate these based on your logic
                sutunnit: 0,
                yotunnit: 0,
                iltatunnit: 0,
                matkatunnit: 0,
                paivystystunnit: 0,
                tsl: false, // Set as per your logic
                userid: props.kayttajaId,
                junat: [],
            };

            // Add new Vuoro to the state
            //alert(JSON.stringify(newVuoro));
            try {
                const response = await fetch("/api/kirjaa", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(newVuoro),
                });

                if (response.ok) {
                    // Handle successful response
                    console.log("Vuoro successfully created:", await response.json());
                    apiKutsu();
                } else {
                    // Handle error response
                    console.error("Failed to create Vuoro:", await response.text());
                }
            } catch (error) {
                console.error("Error occurred during the fetch request:", error);
            }
        }
    };


    const calculateWorkingHours = (startDate: Date, endDate: Date) => {
        const diffInMs = endDate.getTime() - startDate.getTime();
        return diffInMs / (1000 * 60); // Convert ms to hours
    };

    const handleRefreshJuna = async (juna: Juna) => {

        const trainNumber = juna.junanumero;


        try {
            const pvm = format(new Date(juna.pvm), 'yyyy-MM-dd');
            const response = await fetch(`https://rata.digitraffic.fi/api/v1/trains/${pvm}/${trainNumber}`);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: JunanAsemat[] = await response.json();



            if (Array.isArray(data) && data.length > 0) {
                const junatieto = data[0];

                if (junatieto.timeTableRows && Array.isArray(junatieto.timeTableRows)) {

                    const mista = junatieto.timeTableRows.find(
                        row => row.stationShortCode === juna.mista && row.type === 'DEPARTURE'
                    );
                    const mihin = junatieto.timeTableRows.find(
                        row => row.stationShortCode === juna.mihin && row.type === 'ARRIVAL'
                    );
       




                    if ((mista && mista.differenceInMinutes > 0) || (mihin && mihin.differenceInMinutes > 0)) {

                        let lahtomapu: number | undefined = mista?.differenceInMinutes;
                        let saapmapu: number | undefined = mihin?.differenceInMinutes;

                        if (lahtomapu !== undefined && lahtomapu <= 0) {
                            lahtomapu = 0;
                        }
                        if (saapmapu !== undefined && saapmapu <= 0) {
                            saapmapu = 0;
                        }


                        const confirmed = window.confirm(
                            `Haluatko päivittää junan myöhästymisminuutit?\n` +
                            `Lähtöasema: ${juna.mista} - Myöhässä: ${lahtomapu} min\n` +
                            `Määräasema: ${juna.mihin} - Myöhässä: ${saapmapu} min`
                        );

                        if (confirmed) {

                            try {
                                const yhteys = await fetch("/api/kirjaa", {
                                    method: "PUT",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${props.token}`
                                    },
                                    credentials: "include",
                                    body: JSON.stringify({
                                        id: juna.id,
                                        lahtoaikam: lahtomapu,
                                        saapumisaikam: saapmapu
                                    })
                                });


                                if (!yhteys.ok) {
                                    throw new Error("Tietojen päivitys epäonnistui.");
                                }

                                console.log("Tiedot päivitetty onnistuneesti!");
                            } catch (error) {
                                console.error("Virhe tietojen päivityksessä:", error);
                            }


                            apiKutsu();
                            console.log('Päivitetään junan myöhästymisminuutit.');
                        } else {
                            console.log('Päivitys peruutettu.');
                        }

                    }
                    else {
                        alert("Juna ei ollut myöhässä. Hienoa!")
                    }



                } else {
                    throw new Error('Asematiedot eivät ole taulukossa.');
                }
            } else {
                throw new Error('Juna ei löytynyt.');
            }

        } catch (error) {
            console.error('Error fetching train data:', error);
        }

    };
    const handleEdit = async (juna: Juna) => {
        const userInput = prompt("Syötä uusi järjestysnumero:", juna.jarjestysNum?.toString());
        if (userInput !== null) {
            const parsedNum = parseInt(userInput, 10);
            if (isNaN(parsedNum)) {
                alert("Virheellinen numero!");
                return;
            }

            try {
                const yhteys = await fetch("/api/kirjaa", {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${props.token}`
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        id: juna.id,
                        //   lahtoaikam: juna.lahtoaikam,
                        //   saapumisaikam: juna.saapumisaikam,
                        jarjestysNum: parsedNum // Muunnettu numeroksi
                    })
                });

                if (!yhteys.ok) {
                    throw new Error("Tietojen päivitys epäonnistui.");
                }

                console.log("Tiedot päivitetty onnistuneesti!");
                apiKutsu();
                console.log('Päivitetään junan myöhästymisminuutit.');
            } catch (error) {
                console.error("Virhe tietojen päivityksessä:", error);
            }
        } else {
            console.log('Päivitys peruutettu.');
        }
    };



    const handleDeleteVuoro = async (id: number) => {
        const confirmDelete = window.confirm("Haluatko varmasti poistaa tämän vuoron? Tietoa ei voi palauttaa.");

        if (!confirmDelete) return;

        try {

            const response = await fetch(`/api/ajot/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${props.token}`
                },
                credentials: "include",
            });

            if (!response.ok) {
                throw new Error("Poistaminen epäonnistui.");
            }


            setApiData((prevData) => ({
                ...prevData,
                tyovuorot: prevData.tyovuorot.filter((vuoro: Vuoro) => vuoro.id !== id),
            }));

        } catch (error) {
            console.error("Vuoron poistaminen epäonnistui:", error);
            alert("Poistaminen epäonnistui. Yritä uudelleen.");
        }
    };




    const theme = createTheme({
        palette: {
            mode: 'dark',
        },
    });

    const [apiData, setApiData] = useState({
        tyovuorot: [],
        virhe: "",
        haettu: false
    });

    const formatTime = (minutes: number) => {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        let returnString: string;
        if (!hours) {
            returnString = `${remainingMinutes} min`;
        }
        else returnString = `${hours} h ${remainingMinutes} min`;

        return returnString;
    };

    const apiKutsu = async (): Promise<void> => {
        setApiData({
            ...apiData,
            haettu: false
        });

        try {

            if (!props.token) {
                throw new Error("No token found");
            }



            const yhteys = await fetch(`/api/ajot?userid=${props.kayttajaId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${props.token}`
                },
                credentials: "include"
            });

            if (!yhteys.ok) {
                throw new Error("Failed to fetch data");
            }

            setApiData({
                ...apiData,
                tyovuorot: await yhteys.json(),
                haettu: true
            });

        } catch (e: any) {
            setApiData({
                ...apiData,
                virhe: e.message || "Palvelimelle ei saada yhteyttä",
                haettu: true
            });
        }
    };


    useEffect(() => {
        if (props.token) {
            apiKutsu();



        }
        else {
            navigate("/login");
        }
    }, []);


    useEffect(() => {
      //  console.log("apiData saatu: " + JSON.stringify(apiData));
        let suurinJarjestysNum = 0;

        apiData.tyovuorot.forEach((vuoro: Vuoro) => {
            if (vuoro.userid === props.kayttajaId) {


                if (Array.isArray(vuoro.junat)) {
                    const uusiNumero = vuoro.junat.reduce((max, juna) => {
                        return juna.jarjestysNum > max ? juna.jarjestysNum : max;
                    }, 0);

                    suurinJarjestysNum = Math.max(suurinJarjestysNum, uusiNumero);
                    props.setSuurinJarjestysNum(suurinJarjestysNum);
                }
            }
        });

      //  console.log("Suurin jarjestysNum: " + suurinJarjestysNum);


    }, [apiData]);


    const onkoVuoroja = (apiData?.tyovuorot ?? []).some((vuoro: Vuoro) => vuoro.userid === props.kayttajaId);



    useMemo(() => {
        const monthsSet = new Set();
        const yearsSet = new Set();

        apiData?.tyovuorot?.forEach((vuoro: Vuoro) => {
            const vuoroDate = new Date(vuoro.vuoroalkaa);
            const month = (vuoroDate.getMonth() + 1).toString().padStart(2, '0');
            const year = vuoroDate.getFullYear().toString();
            monthsSet.add(`${year}-${month}`);
            yearsSet.add(year);
            setFilteredValmis(true);
        });

        const monthsArray = Array.from(monthsSet).map((dateString: any) => {
            const [year, month] = dateString.split('-');
            return { month, year };
        });

        const yearsArray = Array.from(yearsSet);

        return {
            availableMonths: monthsArray,
            availableYears: yearsArray
        };
    }, [apiData]);

    const JAKSO_ALKU_PVM = new Date("2024-12-30"); // Ensimmäinen jakso alkaa 30.12.2024

    const getTyovuorojakso = (year: number, jakso: number): { startDate: Date, endDate: Date } => {
        // Lasketaan jakson alku 21 päivän sykleissä
        const startDate = new Date(JAKSO_ALKU_PVM);
        startDate.setDate(startDate.getDate() + (jakso - 1) * 21); // Siirretään jakson verran eteenpäin

        // Jakson loppu on 20 päivää aloituksen jälkeen
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 20);

        return { startDate, endDate };
    };


    const filteredVuorot = apiData?.tyovuorot?.filter((vuoro: Vuoro) => {
        const vuoroDate = new Date(vuoro.vuoroalkaa);

        if (valinta === "kuukausi") {
            const month = vuoroDate.getMonth() + 1;
            const year = vuoroDate.getFullYear();
            return month === parseInt(selectedMonth, 10) && year === selectedYear;
        } else if (valinta === "jakso") {
            // Ota työvuoron jakso ja vuoden alku- ja loppupäivämäärät
            const { startDate, endDate } = getTyovuorojakso(selectedYear, parseInt(selectedJakso, 10));
            // Suodata työvuorot, jotka ovat valitun jakson sisällä
            return vuoroDate >= startDate && vuoroDate <= endDate;
        }
        return true; // Jos valinta ei ole kuukausi tai jakso, näyttetään kaikki
    });


    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />




            <Container maxWidth={false} sx={{ padding: 0 }}>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, margin: 2 }}>


                    <>






                        <Stack spacing={2}>
                            {/* Radiopainikkeet */}
                            <FormControl>
                                <RadioGroup row value={valinta} onChange={(e) => setValinta(e.target.value)}>
                                    <FormControlLabel value="kuukausi" control={<Radio />} label="Kuukausi" />
                                    <FormControlLabel value="jakso" control={<Radio />} label="Työvuorojakso" />
                                </RadioGroup>
                            </FormControl>

                            {/* Vuoden valinta (näkyy aina) */}
                            <FormControl sx={{ minWidth: 150 }}>
                                <InputLabel id="year-select-label">Vuosi</InputLabel>
                                <Select
                                    labelId="year-select-label"
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                    displayEmpty
                                    label="Vuosi"
                                    inputProps={{ "aria-label": "Vuoden valinta" }}
                                >
                                    {Array.from({ length: 70 }, (_, i) => {
                                        const year = new Date().getFullYear() + 1 - i;
                                        return (
                                            <MenuItem key={year} value={year}>
                                                {year}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>

                            {/* Kuukauden valinta (vain jos "kuukausi" on valittu) */}
                            {valinta === "kuukausi" && (
                                <FormControl sx={{ minWidth: 150 }}>
                                    <InputLabel id="month-select-label">Kuukausi</InputLabel>
                                    <Select
                                        labelId="month-select-label"
                                        value={selectedMonth}
                                        onChange={handleMonthChange}
                                        displayEmpty
                                        label="Kuukausi"
                                        inputProps={{ "aria-label": "Kuukauden valinta" }}
                                    >
                                        {Array.from({ length: 12 }, (_, i) => (
                                            <MenuItem key={i + 1} value={(i + 1).toString().padStart(2, "0")}>
                                                {new Date(0, i).toLocaleString("fi-FI", { month: "long" })}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}

                            {/* Työvuorojakson valinta (vain jos "jakso" on valittu) */}
                            {valinta === "jakso" && (
                                <FormControl sx={{ minWidth: 150 }}>
                                    <InputLabel id="jakso-select-label">Jakso</InputLabel>
                                    <Select
                                        labelId="jakso-select-label"
                                        value={selectedJakso}
                                        onChange={handleJaksoChange}
                                        displayEmpty
                                        label="Jakso"
                                        inputProps={{ "aria-label": "Jakson valinta" }}
                                    >
                                        {Array.from({ length: 17 }, (_, i) => {
                                            const { startDate, endDate } = getTyovuorojakso(selectedYear, i + 1); // Käytetään valittua vuotta
                                            const startDateFormatted = startDate.toLocaleDateString(); // Muodostetaan päivämäärämuoto
                                            const endDateFormatted = endDate.toLocaleDateString();

                                            return (
                                                <MenuItem key={i + 1} value={i + 1}>
                                                    [ {startDateFormatted} ] - [ {endDateFormatted} ]
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            )}
                        </Stack>


                    </>




                </Box>
                {filteredVuorot?.length > 0 ? (
                    filteredVuorot.map((vuoro: Vuoro, idx: number) => (
                        vuoro.userid === props.kayttajaId && (
                            <Container key={idx} sx={{ padding: 1 }}>
                                <Paper
                                    sx={{ marginBottom: 2 }}
                                    onClick={() => handleAvaaVuoro(vuoro.id)}
                                >




                                    <Typography sx={{ marginBottom: 1 }}>



                                        <Box sx={{
                                            backgroundColor: '#388E3C',
                                            padding: 1,
                                            paddingTop: 2,
                                            paddingBottom: 2,
                                            borderRadius: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            marginTop: 1,
                                        }}>
                                            <i>
                                                {(() => {


                                                    const alotusPaiva = new Date(vuoro.vuoroalkaa).toLocaleDateString('fi-FI', {
                                                        weekday: 'short',
                                                        month: 'long',
                                                        day: 'numeric',
                                                    });

                                                    const alotusAika = new Date(vuoro.vuoroalkaa).toLocaleTimeString('fi-FI', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: false,
                                                    });

                                                    const lopetusAika = new Date(vuoro.vuoroloppuu).toLocaleTimeString('fi-FI', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: false,
                                                    });


                                                    return (
                                                        <>
                                                            <span style={{ display: 'block' }}>{alotusPaiva}</span>
                                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                {alotusAika} - {lopetusAika}
                                                                <TimelapseIcon style={{ height: '0.8em', marginLeft: '0.5em' }} />
                                                                {formatTime(vuoro.tyoaika)}
                                                            </span>
                                                        </>
                                                    );
                                                })()}
                                            </i>

                                            <Box>
                                                <IconButton
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate('/kirjaa', { state: { vuoroid: vuoro.id } });
                                                      //  console.log("Lähetettävä id: " + vuoro.id);
                                                    }}
                                                    sx={{ color: 'white' }}
                                                >
                                                    <EditIcon />
                                                </IconButton>

                                                <IconButton
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteVuoro(vuoro.id);
                                                    }}
                                                    sx={{ color: 'white' }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box>

                                        </Box>





                                    </Typography>
                                    {vuoro?.junat?.length === 0 && (
                                        <Typography variant='body1' sx={{ padding: '25px' }} >Työvuoro on tyhjä</Typography>
                                    )}


                                    {vuoro?.junat?.map((juna: Juna, idx: number) => (

                                        <div key={idx}>

                                            <Box display="flex" alignItems="center">
                                                <Box display="flex" flexDirection="column" justifyContent="space-between" style={{ marginRight: 16 }}>
                                                    <Typography
                                                        variant='h6'
                                                        component='div'
                                                        sx={{ color: 'gray', opacity: 0.7, padding: 1, cursor: 'pointer' }}
                                                        onClick={() => handleEdit(juna)}
                                                    >
                                                        {juna.jarjestysNum}
                                                    </Typography>
                                                </Box>
                                                <Box display="flex" flexDirection="column" flexGrow={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <Typography variant='h6' component='div'>
                                                            <strong>{juna.matkustus ? "m" : ""}{juna.junanumero}</strong>
                                                        </Typography>
                                                        <IconButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRefreshJuna(juna);
                                                            }}
                                                            sx={{ color: 'white', marginLeft: 1 }}
                                                        >
                                                            <RefreshIcon />
                                                        </IconButton>
                                                    </Box>
                                                    <Typography variant='body2' component='div'>
                                                        <strong>{juna.mista} - {juna.mihin}</strong>
                                                        (<strong>{new Date(juna.lahtoaika).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}</strong>
                                                        - <strong>{new Date(juna.saapumisaika).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}</strong>)
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            {avaaVuoro === vuoro.id && (
                                                <>
                                                    <Typography variant='body1'>
                                                        Veturi: {juna.veturi} | Akselit: {juna.akselit} | Pituus: {juna.pituus} | Paino: {juna.junapaino} | JP: {juna.JP} | JPP: {juna.JPP} | Km: {juna.kmM || juna.kmT}
                                                    </Typography>
                                                    {juna.lahtoaikam || juna.saapumisaikam ? (
                                                        <>
                                                            <Typography color='red'>
                                                                Myöhässä [ {juna.mista} {juna.lahtoaikam} min | {juna.mihin} {juna.saapumisaikam} min ]
                                                            </Typography>
                                                            {juna.saapumisaikam > 25 && (
                                                                <Typography color='cyan'>
                                                                    Muista poko!
                                                                </Typography>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <Typography color='green'>
                                                            aikataulussa
                                                        </Typography>
                                                    )}

                                                    <Typography variant='body1'> {juna.vapaateksti}</Typography>
                                                </>
                                            )}
                                            <hr style={{ border: '1px solid #555', margin: '10px 0' }} />
                                        </div>

                                    ))}
                                    <div style={{ textAlign: 'right' }}>

                                    </div>
                                    {avaaVuoro === vuoro.id && (

                                        <TableContainer>
                                            <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                                    <TrainIcon style={{ marginRight: '10px' }} />
                                                    <div style={{ textAlign: 'left' }}>
                                                        <div>
                                                            <strong> Aloitus: </strong>

                                                            {new Date(vuoro.vuoroalkaa).toLocaleDateString('fi-FI', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </div>


                                                        <div>
                                                            <strong>  Lopetus:</strong>

                                                            {new Date(vuoro.vuoroloppuu).toLocaleDateString('fi-FI', {
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <Table>

                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Tuntijakauma</strong></TableCell>
                                                        <TableCell><strong></strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>Työaika</TableCell>
                                                        <TableCell>{formatTime(vuoro.tyoaika)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Ilta / Yö</TableCell>
                                                        <TableCell>{formatTime(vuoro.iltatunnit)} / {formatTime(vuoro.yotunnit)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>La / Su</TableCell>
                                                        <TableCell>{formatTime(vuoro.latunnit)} / {formatTime(vuoro.sutunnit)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Matka h</TableCell>
                                                        <TableCell>{vuoro.matkatunnit} h</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Päiv. h</TableCell>
                                                        <TableCell>{formatTime(vuoro.paivystystunnit)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>TSL</TableCell>
                                                        <TableCell>{vuoro.tsl ? "TSL" : "-"}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )}

                                </Paper>
                                {
                                    vuoro.tsl && (
                                        <Paper
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                border: '2px dashed gray',
                                                borderRadius: '8px',
                                                padding: '16px',
                                            }}
                                        >
                                            <HotelIcon sx={{ fontSize: 50 }} />
                                            <Typography sx={{ fontSize: 40 }}>Lepo</Typography>
                                        </Paper>
                                    )
                                }
                            </Container>

                        )))
                ) : (

                    <>
                        {
                            filteredValmis && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    minHeight="70vh"
                                    flexDirection="column"
                                >
                                    <Typography
                                        variant="h4"
                                        color="textSecondary"
                                        align="center"
                                        sx={{ marginBottom: 1 }}
                                    >
                                        <strong>Huh!</strong>
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        align="center"
                                        sx={{ marginBottom: 1 }}
                                    >
                                        {`Onpas tässä ${valinta === "kuukausi" ? "kuussa" : "jaksossa"} vähän vuoroja...`}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        color="textSecondary"
                                        align="center"
                                        sx={{ marginBottom: 4 }}
                                    >
                                        <strong>Et ole tainnut tehdä kovin ahkerasti töitä?</strong> <br />

                                    </Typography>
                                    <img
                                        src="/laiska.png"
                                        alt="Laiska kuva"
                                        style={{
                                            width: 'auto',
                                            height: '300px',
                                            opacity: 0.6,
                                        }}
                                    />
                                </Box>
                            )
                        }
                    </>
                )}
                {onkoVuoroja ? (
                    <>

                        <Typography variant='body1' align='center'>
                            <Button onClick={vieExceliin}>Vie Exceliin</Button>
                        </Typography>

                        <Typography variant="body1" align="center">
                            <input
                                accept=".ics"
                                style={{ display: 'none' }}
                                id="raised-button-file"
                                type="file"
                                onChange={handleFileUpload}
                            />
                            <label htmlFor="raised-button-file">
                                <Button variant="text" component="span">
                                    AVAA KENTÄN KALENTERITIEDOSTO
                                </Button>
                            </label>
                        </Typography>
                        <Box>
                            {events
                                .filter((event) => {
                                    const eventMonth = new Date(event.startDate).getMonth() + 1; // getMonth() returns 0-indexed months, so we add 1
                                    return eventMonth.toString().padStart(2, '0') === selectedMonth; // Only keep events from the selected month
                                })
                                .map((event, index) => {
                                    // Use the original index from the filtered events
                                    const originalIndex = events.findIndex((e) => e.startDate === event.startDate && e.endDate === event.endDate);
                                    return (
                                        <Box key={originalIndex} display="flex" justifyContent="center" alignItems="center" margin="20px">
                                            <Box display="flex" flexDirection="column" justifyContent="center" marginRight="10px">
                                                <Box onClick={() => handleIconClick(originalIndex)}>
                                                    {selectedEventIndexes.includes(originalIndex) ? (
                                                        <DoneOutlineIcon fontSize="large" />
                                                    ) : (
                                                        <MoreTimeIcon fontSize="large" />
                                                    )}
                                                </Box>
                                            </Box>
                                            <Typography
                                                variant="body1"
                                                align="center"
                                                sx={{
                                                    opacity: selectedEventIndexes.includes(originalIndex) ? 0.5 : 1, // Apply fade effect if selected
                                                }}
                                            >
                                                <Typography variant="body1" align="center" sx={{ opacity: selectedEventIndexes.includes(originalIndex) ? 0.5 : 1 }}>

                                                    {new Date(event.startDate).toLocaleTimeString([], {
                                                        weekday: 'short',
                                                        month: 'long',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })}
                                                    <br />

                                                    {new Date(event.endDate).toLocaleTimeString([], {
                                                        weekday: 'short',
                                                        month: 'long',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })}
                                                </Typography>
                                            </Typography>
                                        </Box>
                                    );
                                })}
                        </Box>

                        <Stack
                            spacing={2}
                            alignItems="center"
                            sx={{
                                p: 3

                            }}
                        >
                            <Typography
                                variant="h6"
                                align="center"
                                sx={{
                                    fontWeight: "bold",
                                    background: "linear-gradient(45deg, #ff8c00, #ff3b3b, #ff0099)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    textShadow: "0px 0px 8px rgba(255,140,0,0.7)",
                                }}
                            >
                                SUPER kiitokset SUPER jäsenille!
                            </Typography>

                            <Stack spacing={1} alignItems="center">
                                <Typography variant="body1" align="center" color="primary.light">
                                    Emppu | Satatama | Player Accordion
                                </Typography>
                                <Typography variant="body2" align="center" color="primary.light">
                                    Haluatko nimesi tähän?{" "}
                                    <Link
                                        href="https://patreon.com/HenkanKoodivarikko?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        color="primary"
                                    >
                                        Liittymällä Patroniksi
                                    </Link>{" "}
                                    se on mahdollista!
                                </Typography>
                            </Stack>
                        </Stack>





                    </>
                ) : (
                    <>
                        {apiData.haettu && (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="70vh"
                                flexDirection="column"
                            >
                                <Typography
                                    variant="h4"
                                    color="textSecondary"
                                    align="center"
                                    sx={{ marginBottom: 1 }}
                                >
                                    <strong>Huh!</strong>
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    align="center"
                                    sx={{ marginBottom: 1 }}
                                >
                                    Onpas täällä vähän vuoroja...
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textSecondary"
                                    align="center"
                                    sx={{ marginBottom: 4 }}
                                >
                                    <strong>Et ole tainnut tehdä kovin ahkerasti töitä?</strong> <br />
                                    <strong>Aloita lisäämällä työvuoro!</strong>
                                </Typography>
                                <img
                                    src="/laiska.png"
                                    alt="Laiska kuva"
                                    style={{
                                        width: 'auto',
                                        height: '300px',
                                        opacity: 0.6,
                                    }}
                                />
                            </Box>
                        )}
                    </>

                )}

            </Container>

        </ThemeProvider >
    );



};

export default Ajot;